import { Warning } from '../constants';
import { useNavigate } from 'react-router-dom';

export const NoAccess = () => {
    const navigate = useNavigate();
    const RedirectToLogin = () => {
        navigate('/login');
    }
    return (
        <div style={{position:'fixed', left:0, right:0, top:0, bottom:0, display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column', width: 445,textAlign: 'center',gap: 18}}>
                <img src={Warning} height={84}/>
                <span style={{fontSize:24, fontWeight:'400', display:'block', color:'rgba(0, 0, 0, 0.87'}}>You don't have access to this tool.</span>
                <span style={{display:'block', fontSize:16, color:'rgba(0, 0, 0, 0.60)', fontWeight:'400',}}>To request access, kindly contact manoj.kumar@bayer.com OR 
tanya.singh1@bayer.com.</span>

                 <button className="assign-button" onClick={RedirectToLogin}>Log Out</button>
            </div>
        </div>
    )
}